import { InspectionAcceptableFileType } from './InspectionAcceptableFileType';

export const InspectionAcceptableFileTypeOptions = [
    {
        id: InspectionAcceptableFileType.JPG,
        name: 'JPG',
        extension: 'jpg',
    },
    {
        id: InspectionAcceptableFileType.PNG,
        name: 'PNG',
        extension: 'png',
    },
    {
        id: InspectionAcceptableFileType.JPEG,
        name: 'JPEG',
        extension: 'jpeg',
    },
    {
        id: InspectionAcceptableFileType.JPE,
        name: 'JPE',
        extension: 'jpe',
    },
    {
        id: InspectionAcceptableFileType.GIF,
        name: 'GIF',
        extension: 'gif',
    },
    {
        id: InspectionAcceptableFileType.BMP,
        name: 'BMP',
        extension: 'bmp',
    },
    {
        id: InspectionAcceptableFileType.TIF,
        name: 'TIF',
        extension: 'tif',
    },
    {
        id: InspectionAcceptableFileType.TIFF,
        name: 'TIFF',
        extension: 'tiff',
    },
    {
        id: InspectionAcceptableFileType.XLSX,
        name: 'XLSX',
        extension: 'xlsx',
    },
    {
        id: InspectionAcceptableFileType.XLS,
        name: 'XLS',
        extension: 'xls',
    },
    {
        id: InspectionAcceptableFileType.DOC,
        name: 'DOC',
        extension: 'doc',
    },
    {
        id: InspectionAcceptableFileType.DOCX,
        name: 'DOCX',
        extension: 'docx',
    },
    {
        id: InspectionAcceptableFileType.PDF,
        name: 'PDF',
        extension: 'pdf',
    },
    {
        id: InspectionAcceptableFileType.PPTX,
        name: 'PPTX',
        extension: 'pptx',
    },
    {
        id: InspectionAcceptableFileType.PPT,
        name: 'PPT',
        extension: 'ppt',
    },
];
